(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.collapsible-text__toggle');
    if (!btn) return;
    var wrapper = btn.closest('.collapsible-text');
    var body = wrapper.querySelector('.collapsible-text__body');
    var moreLabel = wrapper.dataset.moreLabel || 'Read more';
    var lessLabel = wrapper.dataset.lessLabel || 'Show less';

    if (body.classList.contains('collapsible-text--clamped')) {
      body.classList.remove('collapsible-text--clamped');
      btn.textContent = lessLabel;
    } else {
      body.classList.add('collapsible-text--clamped');
      btn.textContent = moreLabel;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
